export const AGENTIC_ASSET_URL = "https://aicc-dev.pimsleur.com/agentic_asset/#/";

export const AICC_CONVERSATION_TYPE = {
  scenario: "scenario",
  lessonReview: "lesson_review",
};

/** Mirrors the backend's ConversationStatus; it has only these two values. */
export const AICC_CONVERSATION_STATUS = {
  active: "active",
  completed: "completed",
};
